import React from "react";
import "./index.css";
import Form from "../form";
import Header from "../header";
import Footer from "../footer";
import GroupLogin from "../form/login/group";
import { Theme } from "discover.medical.react-component-library";
import { WebAuth } from "auth0-js";
import { products } from "../../shared/products";
import axios from "axios";
import {hasOsano, showOsanoDrawer} from "../../hooks/useOsano";

const jwtDecode = require("jwt-decode");
const dhMobileClientId = "platform.medical.dh-mobile-client";
const dmMobileClientId = "platform.medical.dmp-mobile-client";
const dmxMobileClientId = "platform.medical.dmx-mobile-client";
const dsdMobileClientId = "dynamed.shared.decisions-mobile-client"
const mobileClientIds = [dmMobileClientId, dhMobileClientId, dmxMobileClientId, dsdMobileClientId];
class Main extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      webAuth: null,
      form: "login",
      organizationContext: "",
      product: products.default,
      contextToken: "",
      source: "",
      showForm: false,
      myAccountURL: '',
      eisSource: null,
    };
  }

  getProduct(config) {
    if (config.dict && config.dict.signin && config.dict.signin.title) {
      this.clientIdTitle = config.dict.signin.title;
      return products[config.dict.signin.title];
    } else {
      const defaultProduct = products["default"];
      this.clientIdTitle = defaultProduct.productName;
      return defaultProduct;
    }
  }

  // Determine the product
  setProduct(config) {
    const product = this.getProduct(config);
    if (product) {
      this.setState({ product });
      // set tab title
      if (product.title) {
        document.title = product.title;
      }
    }
  }

  // Determine the organization context
  setOrganizationContext(contextToken) {
    // Decode Token and get organization
    let decodedContextToken;
    if (contextToken) {
      decodedContextToken = jwtDecode(contextToken);
      this.setState({
        contextToken,
        organizationContext: decodedContextToken.orgName || "",
      });
    }
  }

  // Initialize and create auth0 webAuth object
  setWebAuth(config, isMobileApp) {
    // This will be the output, whether DH/DM Mobile or otherwise
    let connection;


    // Only do the auto submit for Mobile Clients
    if (isMobileApp) {
      // Remove DMX
      mobileClientIds.splice(2);

      if(mobileClientIds.includes(this.clientIdTitle)) {
        connection = config.extraParams.login_hint;

        // This is specific to DH Mobile only.
        if (
          connection &&
          this.clientIdTitle === dhMobileClientId &&
          connection.toLowerCase() === "s4250101"
        ) {
          connection = "hca";
        }
      }

    } else {
      // This is for anything other than DH & DM Mobile Applications

      // Authorize via Auth0 webAuth
      connection = config.extraParams.connection;
    }

    const params = Object.assign(
      {
        domain: config.auth0Domain,
        clientID: config.clientID,
        redirectUri: config.callbackURL,
        responseType: "code",
        overrides: {
          __tenant: config.auth0Tenant,
          __token_issuer: "https://" + config.auth0Domain,
        },
      },
      config.internalOptions
    );

    const webAuth = new WebAuth(params);
    this.setState({ webAuth: webAuth });

    if (connection) {
      this.setState({ form: "" });

      let authorizeObj = { connection };

      if (isMobileApp) {
        authorizeObj = {
          connection,
          login_hint: connection,
        };
      }

      return webAuth.authorize(authorizeObj);
    }
  }

  // Determine which form to use (login or register)
  setForm(config) {
    const action = config.extraParams.action;
    if (action) {
      const form = action.split("_")[0] || "login";
      const source = action.split("_")[1] || "";
      this.setState({ form, source });
    }
  }

  getUserMapping(config, contextToken) {
    axios
      .get(
        `${config.myAccountURL}/ssoUserMappingCheck?orgToken=${contextToken}`
      )
      .then((res) => {
        this.setState({
          showForm: true,
        });
      })
      .catch((error) => {
        this.setState({
          showForm: true,
        });
      });
  }

  setShowForm = () => {
    this.setState({ showForm: true });
  };

  // Perform initial setup based on EIsAuthConfig
  init() {
    const config = window.EIsAuthConfig;
    
    if (config) {
      const scopeValues = config.internalOptions.scope.split(" ");
      const tokenString = scopeValues.find((val) => val.includes("orgToken"));
      const contextToken = tokenString ? tokenString.split(":")[1] : null;

      let isMobileApp = false;
      this.clientIdTitle = config.dict.signin.title;
      if (this.clientIdTitle && mobileClientIds.includes(this.clientIdTitle)) {
        isMobileApp = true;
      }

      this.setProduct(config);
      this.setOrganizationContext(contextToken);
      this.setWebAuth(config, isMobileApp);
      this.setForm(config);
      this.setState({
        myAccountURL: config.myAccountURL, 
        eisSource: config.internalOptions['eis-source'],
        productName: this.getProduct(config).productName,
        config,
        isMobileApp
      });

      this.setShowForm();
    } else {
      this.setShowForm();
    }
  }

  componentDidMount() {
    this.init();
  }

  handleFormChange = (formName) => {
    this.setState({ form: formName });
  };

  render() {
    const {
      webAuth,
      organizationContext,
      contextToken,
      source,
      product,
      form,
      myAccountURL,
      config,
      isMobileApp
    } = this.state;

    let eisSource;

    if (!form) return null;

    if (config && config.extraParams) {
      eisSource = config.extraParams["eis-source"];
    }

    let productLink = "https://www.dynamed.com";
    if (webAuth && webAuth.baseOptions) {
      const redirectUri = webAuth.baseOptions.redirectUri;
      productLink = new URL(redirectUri).origin;
    }

    let isStripeActivation = false;

    if (config && config.extraParams 
      && config.extraParams.action === "register_subscription") {
      
        isStripeActivation = true;
    }

    const { header, footer } = product;
    return (
      <Theme ui={product.theme}>
        <div className="Main">
          <Header logo={header.logo} />

          {this.state.showForm &&
            <div className="Main__body">
              <Form
                formType={form}
                organizationContext={organizationContext}
                webAuth={webAuth}
                onFormChange={this.handleFormChange}
                contextToken={contextToken}
                fromSource={source}
                groupLogin={product.groupLogin}
                showLinks={product.showLinks}
                forgotPassword={product.forgotPassword}
                productName={product.productName}
                myAccountURL={myAccountURL}
                isMobileApp={product.isMobile}
                eisSource={eisSource}
                config={config}
              />
            {form === "login" && eisSource !== "ehr" && !isStripeActivation && (
              <div className="Login--align-center">
                <GroupLogin 
                  origin={productLink} 
                  showLinks={product.showLinks} 
                  config={config}
                  productName={product.productName}
                  groupLogin={product.groupLogin}
                  isMobileApp={isMobileApp}
                  eisSource={eisSource}
              />
              </div>
            )}
          </div>
          }

          <Footer 
            footerLinks={footer.links} 
            socialLinks={footer.social} 
            config={config} 
            productName={product.productName}
            onManageCookies={hasOsano() ? showOsanoDrawer : null}
            />
        </div>
      </Theme>
    );
  }
}

export default Main;
